import { createFileRoute } from "@tanstack/react-router";
import { Black2x1Page } from "@/components/black2x1/Black2x1Page";

const URL = "https://fisioemortopedia.com.br/black-oferta-alunos";
const TITLE = "BLACK EM DOBRO · Oferta para alunos | FEO";
const DESC = "Oferta exclusiva para quem já é aluno de uma pós da FEO: condição especial na BLACK EM DOBRO.";

export const Route = createFileRoute("/black-oferta-alunos")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: () => <Black2x1Page mode="oferta" variant="alunos" />,
});
